import { reactive } from "vue";
import { StarsMagnetService } from "@/services/stars_magnet.service";
import { emptyFilters } from "./utils";

// Access is checked by the router guard and the Management menu; it's cached here.
export const smAccess = reactive({
  loaded: false,
  member: false,
  admin: false,
  async load(force = false) {
    if (this.loaded && !force) return this;
    const { member, admin } = await StarsMagnetService.getMyAccess();
    this.member = member;
    this.admin = admin;
    this.loaded = true;
    return this;
  },
  reset() {
    this.loaded = false;
    this.member = false;
    this.admin = false;
  },
});

// Shared state for the dashboard, its drawers and dialogs.
export const sm = reactive({
  loaded: false,
  loading: false,
  error: null,
  talents: [],
  members: [],
  filters: emptyFilters(),
  stage: null, // pipeline tile filter

  async load() {
    this.loading = true;
    const [t, m] = await Promise.all([StarsMagnetService.getTalents(), StarsMagnetService.getMembers()]);
    this.error = t.error || m.error || null;
    this.talents = t.talents;
    this.members = m.members;
    this.loaded = !this.error;
    this.loading = false;
  },

  async refreshTalent(influencerId) {
    const { talent } = await StarsMagnetService.getTalent(influencerId);
    const i = this.talents.findIndex((t) => t.influencer_id === influencerId);
    if (talent && i >= 0) this.talents.splice(i, 1, talent);
    else if (talent) this.talents.push(talent);
    else if (i >= 0) this.talents.splice(i, 1);
  },
  async refreshTalents(ids) {
    await Promise.all(ids.map((id) => this.refreshTalent(id)));
  },
  async reloadMembers() {
    const { members } = await StarsMagnetService.getMembers();
    this.members = members;
  },

  talent(id) {
    return this.talents.find((t) => t.influencer_id === id) || null;
  },
  get leads() {
    return this.members.filter((m) => m.is_lead);
  },
  resetFilters() {
    this.filters = emptyFilters();
    this.stage = null;
  },
});
